import { Widget, WidgetSettingType } from '../base/widget/WidgetInterface'
import { WidgetHeightType, WidgetType } from '../base/widget/WidgetTypes'

export const WidgetIframe: Widget = {
  type: WidgetType.iframe,
  noPadding: true,
  title: 'iFrame',
  minSize: 2,
  defaultSize: 10,
  icon: 'Apps',
  defaultHeightType: WidgetHeightType.grid,
  height: 8,
  isFrameless: true,
  customSettings: {
    settings: {
      targetUri: { type: WidgetSettingType.text, title: 'Pfad der Resource', value: 'https://www.divera247.com' },
      showAsImage: { type: WidgetSettingType.checkbox, title: 'Resource als Bild anzeigen', checked: false }
    }
  }
}

export default WidgetIframe
